import { useState, useEffect } from "react";

import Layout from "../components/layout/Layout.component";
import ViagensDetail from "../styles/pages/ViagensDetails";

import Skeleton from "../components/utils/Skeleton.component";
import CardViagens from "../components/data-display/CardViagens..component";

import { CSelect } from "../components";
import { usePacotes } from "../services";
import { Pacote } from "../types";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

function Viagens() {
  const { data, getPacotes, loading } = usePacotes();

  const [dataFilter, setDataFilter] = useState<Pacote[]>(data);
  const [select, setSelect] = useState();

  useEffect(() => {
    getPacotes();
  }, [getPacotes]);

  useEffect(() => {
    if (data && data.length > 0) {
      setDataFilter(data); // Store fetched data in dataFilter
    }
  }, [data]);

  const handleFilter = (e: any) => {
    console.log(e.target.value);
    if (e.target.value === "Todos") {
      setDataFilter(data);
    } else {
      setDataFilter(data.filter((prev) => prev.tag === e.target.value));
      console.log(data.filter((prev) => prev.tag === e.target.value));
    }
  };

  return (
    <Layout>
      <ViagensDetail>
        <div className="content">
          <Breadcrumbs>
            <Link
              underline="hover"
              href="/"
              sx={{ display: "flex", alignItems: "center", color: "black" }}
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Home
            </Link>
            <Typography sx={{ color: "text.primary" }}>Viagens</Typography>
          </Breadcrumbs>
          <div className="content-page">
            <div className="classificar">
              <div className="title">Viagens</div>
              <div className="content-classificar">
                <p>Classificar por</p>
                <div className="select">
                  <CSelect
                    placeholder="Categoria"
                    defaultValue="Todos"
                    data={["Todos", "Pacote", "Caravana", "Excursão"]}
                    onChange={(e) => handleFilter(e)}
                    value={select}
                  />
                </div>
              </div>
            </div>
            <div className="list-viagens">
              {loading ? (
                <>
                  <div className="item-list">
                    <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                  </div>
                  <div className="item-list">
                    <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                  </div>
                  <div className="item-list">
                    <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                  </div>
                  <div className="item-list">
                    <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                  </div>
                </>
              ) : (
                <>
                  {dataFilter.length === 0 ? (
                    <p>Nenhuma viagem cadastrada</p>
                  ) : (
                    <>
                      {dataFilter.map((item, key) => {
                        return (
                          <div
                            className="item-list"
                            key={`${item.title}-${key}`}
                          >
                            <CardViagens data={item} />
                          </div>
                        );
                      })}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </ViagensDetail>
    </Layout>
  );
}

export default Viagens;
